import { configureStore } from "@reduxjs/toolkit";
import { workplaceReducer } from "./features/account/workplaceSlice";
import dialogSlice from "./features/layout/dialogSlice";
import sideNavigationSlice from "./features/layout/sideNavigationSlice";
import appSlice from "./features/apps/appSlice";
import appResourcePageSlice from "./features/apps/appResourcePageSlice";
import workflowSlice from "./features/settings/workflowSlice";
import deploymentsSlice from "./features/deployments/deploymentsSlice";
import provisionsSlice from "./features/provisions/provisionsSlice";
import crmSlice from "./features/crm/crmSlice";
import pageV2Slice from "./features/crm/pageV2Slice";
import { agentChatReducer } from "./features/agentChat/agentChatSlice";
import agentSlice from "./features/agents/agentSlice";
import agentSliceV3 from "./features/agents/agentSliceV3";
import logsSlice from "./features/logs/logsSlice";
import reportsSlice from "./features/reports/reportsSlice";
import threadsReducer from "./features/threads/threadSlice";

export const store = configureStore({
  devTools: {
    name: "Skedyul",
  },
  reducer: {
    workplace: workplaceReducer,
    sideNavigation: sideNavigationSlice,
    dialog: dialogSlice,
    apps: appSlice,
    appResourcePage: appResourcePageSlice,
    workflows: workflowSlice,
    deployments: deploymentsSlice,
    provisions: provisionsSlice,
    crm: crmSlice,
    pageV2: pageV2Slice,
    agentChat: agentChatReducer,
    agents: agentSlice,
    agentsV3: agentSliceV3,
    logs: logsSlice,
    reports: reportsSlice,
    threads: threadsReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
